import { localApi, externalApi } from '../../shared/config/axiosConfig';

// Pure API logic, no Redux!

/**
 *
 * @returns
 */
export const getCurrentAppVersionHub = async () => {
  const response = await localApi({
    url: '/GetCurrentVersion',
    method: 'GET',
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const getLatestAppVersion = async () => {
  const response = await externalApi({
    url: '/user/GetLatestAppVersion',
    method: 'GET',
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const initializeConnection = async (connectionId) => {
  const response = await localApi({
    url: '/Initialize',
    method: 'GET',
    params: { connectionId },
  });
  return response.data;
};

/**
 * Gets non-secret manager installation and pairing state.
 * @returns {Promise<unknown>}
 */
export const getManagerPairingStatus = async () => {
  const response = await localApi({
    url: '/manager/status',
    method: 'GET',
  });
  return response.data;
};

/**
 * Redeems a browser-issued pairing code through the local manager.
 * @param {string} code one-time pairing code
 * @param {string} deviceId stable manager installation identifier
 * @returns {Promise<unknown>}
 */
export const pairManager = async (code, deviceId) => {
  const response = await localApi({
    url: '/manager/pair',
    method: 'POST',
    data: { code, deviceId },
  });
  return response.data;
};
